<template>
  <transition name="br-scan-loading-fade">
    <div v-if="show" class="br-scan-loading" role="status" aria-live="polite" aria-busy="true">
      <div class="br-scan-loading__scrim" />
      <div class="br-scan-loading__dialog">
        <div class="br-scan-loading__spinner" aria-hidden="true" />
        <p class="br-scan-loading__text">{{ message }}</p>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'BrScanLoadingModal',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      default: '',
    },
  },
};
</script>
